import clsx from 'clsx';
import { Box } from '@mui/material';

interface PercentMeterProps {
  valuePercent?: number | string;
  nullValue?: string;
  alarmPercent?: number;
  warnPercent?: number;
}

export function PercentMeter({
  valuePercent,
  nullValue = 'n/a',
  alarmPercent = 10,
  warnPercent = 20,
}: PercentMeterProps) {
  let valueInPercent: number | null = null;
  if (typeof valuePercent === 'number' && valuePercent >= 0) {
    valueInPercent = valuePercent;
  } else if (typeof valuePercent === 'string' && valuePercent) {
    if (!isNaN(parseInt(valuePercent))) valueInPercent = parseInt(valuePercent);
  }

  return (
    <Box
      sx={(theme) => ({
        border: `1px solid ${theme.palette.divider}`,
        position: 'relative',
        overflow: 'hidden',
        width: '100%',
        height: 26,
        borderRadius: 2,
      })}
    >
      <Box
        sx={{
          position: 'absolute',
          lineHeight: '24px',
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
        }}
      >{`${valueInPercent !== null ? valueInPercent.toLocaleString() + ' %' : nullValue}`}</Box>
      <Box
        className={clsx(
          valueInPercent !== null
            ? {
                alarm: valueInPercent <= alarmPercent,
                warn: valueInPercent > alarmPercent && valueInPercent <= warnPercent,
                nominal: valueInPercent > warnPercent,
              }
            : undefined
        )}
        sx={(theme) => ({
          height: '100%',
          maxWidth: valueInPercent ? `${valueInPercent}%` : 0,
          '&.alarm': {
            backgroundColor: theme.palette.error.main,
          },
          '&.warn': {
            backgroundColor: theme.palette.warning.main,
          },
          '&.nominal': {
            backgroundColor: theme.palette.success.light,
          },
        })}
      />
    </Box>
  );
}
